import React from "react";
import { Dialog, Box, Grid, Typography, FormControl, Select, MenuItem } from "@mui/material";
import api from "../../Api/apiAxios";
import Mensagem from "../../Components/Mensagem";
import { ButtonBase, FormSectionTitle } from "../Pedidos/styles";
import Loading from "../../Components/Loading";

const ConfiguracaoSisdm = ({ show, onHide }) => {
    const [tiposServicos, setTiposServicos] = React.useState([]);
    const [tipoServicoPadraoContratoId, setTipoServicoPadraoContratoId] = React.useState('');
    const [configId, setConfigId] = React.useState(0);
    const [mensagem, setMensagem] = React.useState('');
    const [tipoMensagem, setTipoMensagem] = React.useState('');
    const [showMensagem, setShowMensagem] = React.useState(false);
    const [isSaving, setIsSaving] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [sisdmStatus, setSisdmStatus] = React.useState(null);

    async function validarSisdm(tipoId, lista) {
        const tipos = lista || tiposServicos;
        setSisdmStatus(null);
        if (!tipoId) return;
        const tipo = tipos.find(t => String(t.id) === String(tipoId));
        if (!tipo || !tipo.codigoServicoSisdm) { setSisdmStatus('sem-codigo'); return; }
        setSisdmStatus('loading');
        try {
            const res = await api.get('/Sisdm/validar-servico/' + tipo.codigoServicoSisdm);
            setSisdmStatus(res.data.valido ? 'valido' : 'invalido');
        } catch { setSisdmStatus(null); }
    }

    React.useEffect(() => {
        if (!show) { setSisdmStatus(null); return; }
        setShowMensagem(false);
        setIsLoading(true);
        async function carregar() {
            try {
                const [configResp, tiposResp] = await Promise.all([
                    api.get('/ConfiguracaoSisdm'),
                    api.get('/TipoServico')
                ]);
                const tiposLista = Array.isArray(tiposResp.data) ? tiposResp.data : [];
                setTiposServicos(tiposLista);
                setConfigId(configResp.data.id || 0);
                const tipoAtual = configResp.data.tipoServicoPadraoContratoId;
                setTipoServicoPadraoContratoId(tipoAtual != null ? String(tipoAtual) : '');
                if (tipoAtual) {
                    const tipo = tiposLista.find(t => String(t.id) === String(tipoAtual));
                    if (!tipo || !tipo.codigoServicoSisdm) {
                        setSisdmStatus('sem-codigo');
                    } else {
                        setSisdmStatus('loading');
                        api.get('/Sisdm/validar-servico/' + tipo.codigoServicoSisdm)
                            .then(res => setSisdmStatus(res.data.valido ? 'valido' : 'invalido'))
                            .catch(() => setSisdmStatus(null));
                    }
                }
            } catch (e) {
                setMensagem('Erro ao carregar configuração.');
                setTipoMensagem('danger');
                setShowMensagem(true);
            } finally {
                setIsLoading(false);
            }
        }
        carregar();
    }, [show]);

    async function handleSalvar(event) {
        event.preventDefault();
        setShowMensagem(false);
        setIsSaving(true);
        try {
            const ret = await api.put(
                '/ConfiguracaoSisdm',
                {
                    id: configId,
                    tipoServicoPadraoContratoId: tipoServicoPadraoContratoId !== ''
                        ? Number(tipoServicoPadraoContratoId)
                        : null
                },
                { headers: { 'Content-Type': 'application/json' } }
            );
            if (ret.data && ret.data.id) setConfigId(ret.data.id);
            onHide();
        } catch (e) {
            setMensagem('Erro ao salvar configuração.');
            setTipoMensagem('danger');
            setShowMensagem(true);
        } finally {
            setIsSaving(false);
        }
    }

    return (
        <Dialog open={show} onClose={onHide} maxWidth="sm" fullWidth PaperProps={{ sx: { backgroundColor: 'transparent', boxShadow: 'none' } }}>
          {showMensagem && (
              <Mensagem mensagem={mensagem} setMensagem={setMensagem} variant={tipoMensagem} />
          )}
          <Box sx={{
              backgroundColor: 'white',
              py: 3,
              px: 4,
              my: 3,
              borderRadius: '30px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'start',
              width: '100%',
              position: 'relative',
              boxShadow: '0px 0px 7px rgba(0, 0, 0, 0.25)',
          }}>
              <FormSectionTitle label="Configuração de Integração SISDM" />

              {isLoading ? <Loading /> : (
                  <form onSubmit={handleSalvar} style={{ width: '100%' }}>
                      <Grid container spacing={2} sx={{ mt: 1 }}>
                          <Grid item xs={12}>
                              <Typography variant="subtitle1" fontWeight={600}>
                                  Tipo de Serviço Padrão para Contratos
                              </Typography>
                          </Grid>

                          <Grid item xs={12}>
                              <Box sx={{ position: 'relative' }}>
                                  {sisdmStatus && (
                                      <Typography variant="caption" sx={{
                                          position: 'absolute', top: -10, right: 8, zIndex: 1,
                                          backgroundColor: 'white', px: 0.5, fontSize: '0.7rem',
                                          color: { valido: 'success.main', invalido: 'warning.main', 'sem-codigo': 'error.main', loading: 'text.secondary' }[sisdmStatus]
                                      }}>
                                          {{ loading: 'Validando...', 'sem-codigo': 'Cód. SISDM não configurado', invalido: '✗ Não encontrado no SISDM', valido: '✓ Código validado no SISDM' }[sisdmStatus]}
                                      </Typography>
                                  )}
                                  <FormControl fullWidth>
                                      <Select
                                          value={tipoServicoPadraoContratoId}
                                          onChange={({ target }) => { setTipoServicoPadraoContratoId(target.value); validarSisdm(target.value); }}
                                          displayEmpty
                                      >
                                          <MenuItem value=""><em>Nenhum</em></MenuItem>
                                          {tiposServicos.map(t => (
                                              <MenuItem key={t.id} value={String(t.id)}>{t.tituloTipo}</MenuItem>
                                          ))}
                                      </Select>
                                  </FormControl>
                              </Box>
                          </Grid>

                          <Grid item xs={12}>
                              <Typography variant="body2" color="text.secondary" textAlign='left' fontSize='small'>
                                  Este tipo de serviço será vinculado automaticamente a todos os pedidos que gerarem contrato.
                              </Typography>
                          </Grid>

                          <Grid item xs={6} />

                          <Grid item xs={3}>
                              <ButtonBase
                                  type="submit"
                                  variant="contained"
                                  fullWidth
                                  sx={{ mt: 2 }}
                                  disabled={isSaving}
                              >
                                  Salvar
                              </ButtonBase>
                          </Grid>

                          <Grid item xs={3}>
                              <ButtonBase
                                  variant="outlined"
                                  onClick={onHide}
                                  fullWidth
                                  sx={{ mt: 2 }}
                              >
                                  Voltar
                              </ButtonBase>
                          </Grid>
                      </Grid>
                  </form>
              )}
          </Box>
        </Dialog>
    );
};

export default ConfiguracaoSisdm;
